import { useContext } from 'react';
import styled from 'styled-components';

import Loading from 'components/Loading/Loading';
import NewUserButtonContainer from 'components/Settings/NewUserButton';
import { PortalsContext } from 'contextProviders/SplashScreenProviders/UserAndAccountProviders/PortalsProvider';
import TextInput from 'kingpin/atoms/TextInput';
import NAVIGATION from 'kingpin/navigation/constants';
import NavItem from 'kingpin/navigation/NavItem';
import { buildShowUser } from 'navigation/appRoutes';

const Top = styled.div`
  height: ${NAVIGATION.TOP_HEIGHT}px;
  min-height: ${NAVIGATION.TOP_HEIGHT}px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 16px;
  border-bottom: 1px solid var(--color-border-secondary);
  width: 100%;

  span {
    color: var(--color-text-primary);
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 26px; /* 185.714% */
    letter-spacing: -0.042px;
  }
`;

const SidebarDiv = styled.div`
  width: 260px;
  min-width: 260px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  border-right: 1px solid var(--color-border-secondary);
  overflow: hidden;
  position: relative;
`;

const AddUserBtnDiv = styled.div`
  width: 100%;
`;

const UsersList = styled.div`
  width: 100%;
  padding: 16px 10px;
  overflow-y: auto;
`;

const UsersSidebar = ({
  users,
  isLoading,
  searchText,
  onSearchTextChanged,
}: {
  users: (UserManagement.PendingUser | UserManagement.SignedUpUser)[];
  isLoading: boolean;
  searchText: string;
  onSearchTextChanged: (event: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
  const { selectedPortal } = useContext(PortalsContext);

  return (
    <SidebarDiv>
      <Top>
        <span>Users</span>
      </Top>
      <AddUserBtnDiv>
        <NewUserButtonContainer />
      </AddUserBtnDiv>
      <div style={{ padding: '16px 8px 8px', width: '100%', marginBottom: 4 }}>
        <TextInput
          value={searchText}
          onChange={onSearchTextChanged}
          inputSize="Small"
          placeholder="Search"
          icon="search"
          width="100%"
          autoFocus
        />
      </div>
      <UsersList>
        {isLoading && <Loading />}
        {users.map((user) => (
          <NavItem
            isTall
            key={user.id}
            to={buildShowUser(user.id, selectedPortal)}
            label={user.displayName}
          />
        ))}
      </UsersList>
    </SidebarDiv>
  );
};

export default UsersSidebar;
